import { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Button,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import { UseProductCluster } from "./UseProductCluster";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import { removeComma, toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddCluster() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getclusterSortlist, validate, addcluster } = UseProductCluster();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [state, setState] = useState({
    available: false,
    withDiscount: false,
    withGift: false,
    title: undefined,
    sort: undefined,
    gender: undefined,
    minCost: undefined,
    maxCost: undefined,
    gridCount: undefined,
    expireDay: undefined,
    spf: undefined,
    isherbal: false,
    isNatural: false,
    isTraditional: false,
  });

  const [expireScale, setExpireScale] = useState(undefined);
  const [sortList, setSortList] = useState(false);
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const options = [
    { label: "آقایان", id: 1 },
    { label: "بانوان", id: 2 },
  ];

  const LessMore = [
    { id: 1, value: "بیشتر" },
    { id: 2, value: "کمتر" },
  ];

  useEffect(() => {
    setProgress(true);
    getclusterSortlist((sorts) => {
      setSortList(sorts);
    });
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productcluster" },
          { name: "افزودن خوشه محصول", url: "/productcluster/addCluster" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            error={errorState.title}
            label="عنوان"
            value={state.title ? state.title : ""}
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          {sortList && (
            <Autocomplete
              size="small"
              value={state.sort ? state.sort : undefined}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, sort: newValue });
                } else {
                  setState({ ...state, sort: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option || option == 0) {
                  return sortList?.find((m) => m.id == option)?.title;
                }
                return "";
              }}
              fullWidth
              options={sortList ? sortList.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  {...params}
                  label="مرتب سازی بر اساس"
                />
              )}
            />
          )}
        </Box>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <Autocomplete
            size="small"
            value={state.gender ? state.gender : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({ ...state, gender: newValue });
              } else {
                setState({ ...state, gender: undefined });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return options?.find((m) => m.id == option).label;
              }
              return "";
            }}
            sx={{ width: "80%" }}
            fullWidth
            options={options.map((m) => m.id)}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="جنسیت" />
            )}
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            قیمت :
          </Typography>
          <TextField
            fullWidth
            sx={{ width: "35%", input: { direction: "rtl" } }}
            label="از"
            value={state.minCost ? toMoney(state.minCost) : ""}
            onChange={(evt) => {
              setState({ ...state, minCost: removeComma(evt.target.value) });
            }}
            size="small"
            variant="outlined"
          />
          <TextField
            fullWidth
            sx={{ width: "35%", input: { direction: "rtl" } }}
            label="تا"
            value={state.maxCost ? toMoney(state.maxCost) : ""}
            onChange={(evt) => {
              setState({ ...state, maxCost: removeComma(evt.target.value) });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 1"></Box>}{" "}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            تعداد نمایش در صفحه :
          </Typography>
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
              width: "30%",
            }}
            label="عدد"
            value={state.gridCount ? state.gridCount : ""}
            onChange={(evt) => {
              if (evt.target.value) {
                setState({
                  ...state,
                  gridCount: evt.target.value,
                });
              } else {
                setState({
                  ...state,
                  gridCount: undefined,
                });
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          gridColumn={isSmall ? "span 12" : "span 5"}
        >
          <Typography color="secondary" variant="subtitle1">
            تاریخ انقضا :
          </Typography>
          <Autocomplete
            size="small"
            value={expireScale !== undefined ? expireScale : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                if (state.expireDay && newValue == 1) {
                  setState({
                    ...state,
                    expireDay: Math.abs(state.expireDay),
                  });
                } else if (state.expireDay && newValue == 2) {
                  setState({
                    ...state,
                    expireDay: 0 - Math.abs(state.expireDay),
                  });
                }
                setExpireScale(newValue);
              } else {
                setState({
                  ...state,
                  expireDay: undefined,
                });
                setExpireScale(undefined);
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return LessMore?.find((m) => m.id == option).value;
              }
              return "";
            }}
            sx={{ width: "40%" }}
            options={LessMore.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                {...params}
                label="مقیاس"
              />
            )}
          />
          <Typography color="secondary" variant="subtitle1">
            از
          </Typography>
          <TextField
            sx={{
              input: {
                textAlign: "center",
                // direction: "rtl",
              },
              width: "30%",
            }}
            label="روز"
            value={state.expireDay ? Math.abs(state.expireDay) : ""}
            onChange={(evt) => {
              if (evt.target.value) {
                if (expireScale == 1) {
                  setState({
                    ...state,
                    expireDay: evt.target.value,
                  });
                } else if (expireScale == 2) {
                  setState({
                    ...state,
                    expireDay: 0 - Math.abs(evt.target.value),
                  });
                }
              } else {
                setState({
                  ...state,
                  expireDay: undefined,
                });
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 1"></Box>}{" "}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 3"}
        >
          <Typography color="secondary" variant="subtitle1">
            spf :
          </Typography>
          <TextField
            fullWidth
            label="spf"
            sx={{ width: "50%", input: { textAlign: "center" } }}
            value={state.spf ? state.spf : ""}
            onChange={(evt) => {
              setState({ ...state, spf: evt.target.value });
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box gridColumn="span 5"></Box>
        <Box gridColumn="span 12">
          <FormControlLabel
            checked={state.available ? state.available : false}
            onChange={(evt) => {
              setState({ ...state, available: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات موجود"
          />
          <FormControlLabel
            checked={state.withDiscount ? state.withDiscount : false}
            onChange={(evt) => {
              setState({ ...state, withDiscount: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات با تخفیف"
          />
          <FormControlLabel
            checked={state.withGift ? state.withGift : false}
            onChange={(evt) => {
              setState({ ...state, withGift: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات با هدیه"
          />
        </Box>
        <Box sx={{ mt: 1 }} gridColumn="span 12">
          <FormControlLabel
            checked={state.isherbal ? state.isherbal : false}
            onChange={(evt) => {
              setState({ ...state, isherbal: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات گیاهی"
          />
          <FormControlLabel
            checked={state.isNatural ? state.isNatural : false}
            onChange={(evt) => {
              setState({ ...state, isNatural: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات طبیعی"
          />
          <FormControlLabel
            checked={state.isTraditional ? state.isTraditional : false}
            onChange={(evt) => {
              setState({ ...state, isTraditional: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="محصولات طب سنتی"
          />
        </Box>
        <Box gridColumn="span 7"></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
          }}
          gridColumn="span 12"
        >
          <Button
            variant="contained"
            sx={{ mr: 2, width: "100px" }}
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                setMsGotoLast(true);
                addcluster(state, () => {
                  navigate("/productcluster", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            color="secondary"
            variant="outlined"
            onClick={() => {
              navigate("/productcluster", {
                state: location.state,
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
